import http from '@/utils/http.js' // 引入封装的request.js文件
import common from '@/config/common.js'

// 查询通知公告
export function queryNoticeList(data) {
    return http.request({
        url: common.url + '/papi/notice/list',
        method: 'get',
        params: data
    })
}

//查询通知公告
export function queryNoticeById(wid) {
    return http.request({
        url: common.url + '/papi/notice/' + wid,
        method: 'get',
    })
}

